import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const FAQS = [{
  q: '¿Necesito ser diseñador o copywriter?',
  a: 'No. Necesitás criterio para testear y medir. Techain te entrega volumen y estructura.'
}, {
  q: '¿Esto me garantiza ventas?',
  a: 'No vendo magia. Te da lo que hoy te falta: volumen + ángulos + velocidad. Lo que hagas con eso (testear en serio) define el resultado.'
}, {
  q: '¿Ya probé Sora/Higgsfield/Canva… por qué esto sería distinto?',
  a: 'Porque esas herramientas te ponen en modo "artesano". Techain te pone en modo testing: 100 piezas, ahora, para encontrar ganadores rápido.'
}, {
  q: '¿Tiene algún límite de creación?',
  a: 'No. Como conectás tu propia API de Google AI Studio (que es gratuita en su capa estándar), no tenés límites arbitrarios de la plataforma.'
}, {
  q: '¿Sirve para ebooks y cursos?',
  a: 'Sí. Está pensado para ofertas digitales donde el creativo tiene que vender promesa, claridad y transformación.'
}, {
  q: '¿Genera imágenes y videos?',
  a: 'Por ahora Techain genera imágenes estáticas optimizadas para ads. Es lo que más impacto tiene en testing de volumen. Video viene más adelante.'
}, {
  q: '¿Hay algún plan gratuito para probar?',
  a: 'No. No ofrecemos plan free. Lo que sí ofrecemos es una garantía total de 72hs: si no te convence, te devolvemos el 100%. Además, tenemos cientos de resultados reales de usuarios que prueban que funciona.'
}, {
  q: '¿Es un pago único o suscripción?',
  a: 'Es una suscripción mensual. Pagás mes a mes y podés cancelar o pausar cuando quieras, sin permanencia ni penalidades. Si querés probar un mes y ver los resultados, podés hacerlo sin ningún compromiso.'
}];
function FAQItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-white/10 last:border-0" data-id="element-33">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-5 md:py-6 flex items-center justify-between text-left hover:text-purple-400 transition-colors" data-id="element-34">
        <span className="font-bold text-base md:text-xl pr-8" data-id="element-35">{q}</span>
        <span className="flex-shrink-0 text-purple-500" data-id="element-36">
          {isOpen ? <Minus className="w-5 h-5" data-id="element-37" /> : <Plus className="w-5 h-5" data-id="element-38" />}
        </span>
      </button>
      <AnimatePresence data-id="element-39">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-40">
            <p className="pb-6 text-gray-400 leading-relaxed text-sm md:text-base" data-id="element-41">
              {a}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  return <section className="py-16 md:py-24 bg-[#050505]" data-id="element-42">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-43">
        <h2 className="text-3xl md:text-4xl font-bold mb-10 md:mb-12 text-center" data-id="element-44">
          Preguntas Frecuentes
        </h2>
        <div className="bg-white/[0.02] rounded-2xl p-5 md:p-8 border border-white/5" data-id="element-45">
          {FAQS.map((faq, i) => <FAQItem key={i} {...faq} data-id="element-46" />)}
        </div>
      </div>
    </section>;
}